import React from 'react';
import { Link } from 'react-router-dom';
import './InfoPage.css';

function Sitemap() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Mapa do Site</h1>

        <section className="info-section">
          <h2>Navegue pela Nukki</h2>
          <p>Encontre todas as páginas e recursos disponíveis na plataforma Nukki.</p>
        </section>

        <section className="info-section">
          <h3>Páginas Principais</h3>
          <div className="help-topic">
            <ul>
              <li><Link to="/">Início</Link></li>
              <li><Link to="/properties">Explorar Propriedades</Link></li>
              <li><Link to="/login">Entrar</Link></li>
              <li><Link to="/register">Registrar</Link></li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Para Hóspedes</h3>
          <div className="help-topic">
            <h4>Reservas e Viagens</h4>
            <ul>
              <li><Link to="/properties">Pesquisar Propriedades</Link></li>
              <li><Link to="/dashboard">Minhas Viagens</Link></li>
              <li><Link to="/messages">Mensagens</Link></li>
              <li><Link to="/profile">Meu Perfil</Link></li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Suporte e Informações</h4>
            <ul>
              <li><Link to="/help">Central de Ajuda</Link></li>
              <li><Link to="/safety">Informações de Segurança</Link></li>
              <li><Link to="/cancellation">Opções de Cancelamento</Link></li>
              <li><Link to="/covid">Resposta COVID-19</Link></li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Para Anfitriões</h3>
          <div className="help-topic">
            <h4>Hospedagem</h4>
            <ul>
              <li><Link to="/host">Torne-se um Anfitrião</Link></li>
              <li><Link to="/create-property">Criar um Anúncio</Link></li>
              <li><Link to="/host-dashboard">Painel do Anfitrião</Link></li>
              <li><Link to="/messages">Mensagens do Anfitrião</Link></li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Recursos</h4>
            <ul>
              <li><Link to="/host/resources">Recursos para Anfitriões</Link></li>
              <li><Link to="/host/community">Fórum da Comunidade</Link></li>
              <li><Link to="/host/responsible">Hospedagem Responsável</Link></li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Empresa</h3>
          <div className="help-topic">
            <ul>
              <li><Link to="/about">Sobre Nós</Link></li>
              <li><Link to="/careers">Carreiras</Link></li>
              <li><Link to="/press">Imprensa e Mídia</Link></li>
              <li><Link to="/investors">Relações com Investidores</Link></li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Legal e Privacidade</h3>
          <div className="help-topic">
            <ul>
              <li><Link to="/privacy">Política de Privacidade</Link></li>
              <li><Link to="/terms">Termos de Serviço</Link></li>
              <li><Link to="/sitemap">Mapa do Site</Link></li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Destinos Populares</h3>
          <div className="feature-grid">
            <div className="feature-box">
              <h4>Estados Unidos</h4>
              <ul>
                <li>Nova York, NY</li>
                <li>Los Angeles, CA</li>
                <li>São Francisco, CA</li>
                <li>Miami, FL</li>
                <li>Las Vegas, NV</li>
              </ul>
            </div>
            <div className="feature-box">
              <h4>Europa</h4>
              <ul>
                <li>Paris, França</li>
                <li>Londres, Reino Unido</li>
                <li>Roma, Itália</li>
                <li>Barcelona, Espanha</li>
                <li>Amsterdã, Holanda</li>
              </ul>
            </div>
            <div className="feature-box">
              <h4>Ásia</h4>
              <ul>
                <li>Tóquio, Japão</li>
                <li>Bangkok, Tailândia</li>
                <li>Singapura</li>
                <li>Seul, Coreia do Sul</li>
                <li>Bali, Indonésia</li>
              </ul>
            </div>
            <div className="feature-box">
              <h4>Outras Regiões</h4>
              <ul>
                <li>Sydney, Austrália</li>
                <li>Dubai, Emirados Árabes Unidos</li>
                <li>Cidade do Cabo, África do Sul</li>
                <li>Cidade do México, México</li>
                <li>Rio de Janeiro, Brasil</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Tipos de Propriedade</h3>
          <div className="feature-grid">
            <div className="feature-box">
              <h4>Acomodações</h4>
              <ul>
                <li>Apartamentos</li>
                <li>Casas</li>
                <li>Vilas</li>
                <li>Condomínios</li>
                <li>Chalés</li>
                <li>Cabanas</li>
              </ul>
            </div>
            <div className="feature-box">
              <h4>Estadias Únicas</h4>
              <ul>
                <li>Casas na Árvore</li>
                <li>Barcos</li>
                <li>Minicasas</li>
                <li>Castelos</li>
                <li>Yurts</li>
                <li>Iglus</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Links Rápidos</h3>
          <div className="help-topic">
            <ul>
              <li><Link to="/help">Entrar em Contato com o Suporte</Link></li>
              <li><Link to="/host">Anuncie sua Propriedade</Link></li>
              <li><Link to="/about">Conheça a Nukki</Link></li>
              <li><Link to="/careers">Junte-se à Nossa Equipe</Link></li>
              <li><Link to="/safety">Confiança e Segurança</Link></li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Redes Sociais</h3>
          <div className="help-topic">
            <p>Siga-nos nas redes sociais para atualizações e inspiração:</p>
            <ul>
              <li>Facebook: @nukki</li>
              <li>Twitter: @nukki</li>
              <li>Instagram: @nukki</li>
              <li>LinkedIn: /company/nukki</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Precisa de Ajuda?</h3>
          <p>Não encontrou o que procura? Visite nossa <Link to="/help">Central de Ajuda</Link> ou entre em contato com nossa equipe de suporte.</p>
        </section>
      </div>
    </div>
  );
}

export default Sitemap;
